import { render } from "./header-extra.vue?vue&type=template&id=a85304d6"
import script from "./header-extra.vue?vue&type=script&setup=true&lang=js"
export * from "./header-extra.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/orders/pages/order-details/components/header-extra.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a85304d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a85304d6', __exports__)) {
    console.log('reload')
    api.reload('a85304d6', __exports__)
  }
  
  module.hot.accept("./header-extra.vue?vue&type=template&id=a85304d6", () => {
    console.log('re-render')
    api.rerender('a85304d6', render)
  })

}


export default __exports__